module.exports = __webpack_public_path__ + "static/pasarela-pago-bono-cultural-e85f418b0e0b8c97ed1f7fd1df6cf483.png";